/**
 * Author: BaiJiFeiLong@gmail.com
 * Datetime: 2017/6/24 下午2:49
 */

export const configFields = {
    // androidInReview: {
    //     type: 'boolean',
    //     title: '安卓审核中'
    // },
    // iosInReview: {
    //     type: 'boolean',
    //     title: 'iOS审核中'
    // },
    androidVersion: {
        type: 'string',
        title: 'Android版本'
    },
    iosVersion: {
        type: 'string',
        title: 'iOS版本'
    },
    harmonyVersion: {
        type: 'string',
        title: '鸿蒙版本'
    },
    androidReviewVersion: {
        type: 'string',
        title: 'Android审核版本'
    },
    iosReviewVersion: {
        type: 'string',
        title: 'iOS审核版本'
    },
    harmonyReviewVersion: {
        type: 'string',
        title: '鸿蒙审核版本'
    },
    isAuditMode: {
        type: 'boolean',
        title: '国内是否审核模式'
    },
    androidNewVersion: {
        type: 'string',
        title: 'Android-Assetbundle版本'
    },
    iosNewVersion: {
        type: 'string',
        title: 'ios-Assetbundle版本'
    },
    harmonyNewVersion: {
        type: 'string',
        title: '鸿蒙-Assetbundle版本'
    },

    isAndroidUpdate: {
        type: 'boolean',
        title: '开启Android更新'
    },

    isIosUpdate: {
        type: 'boolean',
        title: '开启iOS更新'
    },
    isHarmonyUpdate: {
        type: 'boolean',
        title: '开启鸿蒙更新'
    },

    androidUpdateDescription: {
        type: 'text',
        title: 'Android更新文案'
    },
    iosUpdateDescription: {
        type: 'text',
        title: 'iOS更新文案'
    },
    harmonyUpdateDescription: {
        type: 'text',
        title: '鸿蒙更新文案'
    },
    iosForceUpdate: {
        type: 'boolean',
        title: 'ios强制更新'
    },
    androidForceUpdate: {
        type: 'boolean',
        title: 'android强制更新'
    },
    harmonyForceUpdate: {
        type: 'boolean',
        title: '鸿蒙强制更新'
    },
    isJudgeVendor: {
        type: 'boolean',
        title: '开启国内苹果内购'
    },
    isVpnModel: {
        type: 'boolean',
        title: '线上版本开启VPN判断'
    },
    isCodeModel: {
        type: 'boolean',
        title: '线上版本开启优惠码'
    },
    voiceHighUrl: {
        type: 'audio',
        title: '音高了'
    },
    voiceLowUrl: {
        type: 'audio',
        title: '音低了'
    },
    voiceOkUrl: {
        type: 'audio',
        title: '音准了'
    },
    voicePrompt: {
        type: 'audio',
        title: '语音识别'
    },
    tutorialInfo: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfo: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfo: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitle: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitle: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButton: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonType: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomText: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValue: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCount: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTime: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoGuitar: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoGuitar: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoGuitar: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleGuitar: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleGuitar: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonGuitar: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeGuitar: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextGuitar: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueGuitar: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountGuitar: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeGuitar: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoKalimba: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoKalimba: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoKalimba: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleKalimba: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleKalimba: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonKalimba: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeKalimba: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextKalimba: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueKalimba: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountKalimba: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeKalimba: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoDjembe: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoDjembe: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoDjembe: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleDjembe: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleDjembe: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonDjembe: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeDjembe: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextDjembe: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueDjembe: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountDjembe: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeDjembe: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoPiano: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoPiano: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoPiano: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitlePiano: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitlePiano: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonPiano: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypePiano: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextPiano: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValuePiano: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountPiano: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimePiano: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoHarmonica: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoHarmonica: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoHarmonica: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleHarmonica: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleHarmonica: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonHarmonica: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeHarmonica: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextHarmonica: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueHarmonica: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountHarmonica: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeHarmonica: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoOther: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoOther: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoOther: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleOther: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleOther: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonOther: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeOther: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextOther: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueOther: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountOther: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeOther: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoSaxophone: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoSaxophone: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoSaxophone: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleSaxophone: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleSaxophone: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonSaxophone: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeSaxophone: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextSaxophone: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueSaxophone: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountSaxophone: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeSaxophone: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoZhudi: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoZhudi: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoZhudi: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleZhudi: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleZhudi: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonZhudi: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeZhudi: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextZhudi: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueZhudi: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountZhudi: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeZhudi: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoBass: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoBass: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoBass: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleBass: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleBass: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonBass: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeBass: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextBass: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueBass: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountBass: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeBass: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoEguitar: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoEguitar: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoEguitar: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleEguitar: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleEguitar: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonEguitar: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeEguitar: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextEguitar: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueEguitar: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountEguitar: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeEguitar: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoGuzheng: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoGuzheng: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoGuzheng: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleGuzheng: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleGuzheng: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonGuzheng: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeGuzheng: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextGuzheng: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueGuzheng: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountGuzheng: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeGuzheng: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoOcarina: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoOcarina: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoOcarina: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleOcarina: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleOcarina: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonOcarina: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeOcarina: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextOcarina: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueOcarina: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountOcarina: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeOcarina: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoVocal: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoVocal: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoVocal: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleVocal: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleVocal: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonVocal: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeVocal: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextVocal: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueVocal: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountVocal: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeVocal: {
        type: 'text',
        title: '总平均练习时间'
    },

    tutorialInfoParent: {
        type: 'text',
        title: '新手入门文案'
    },
    advanceInfoParent: {
        type: 'text',
        title: '进阶课程文案'
    },
    parentingInfoParent: {
        type: 'text',
        title: '亲子课文案'
    },
    welcomeTitleParent: {
        type: 'text',
        title: '欢迎主标题文案'
    },
    welcomeSubtitleParent: {
        type: 'text',
        title: '欢迎子标题文案'
    },
    welcomeButtonParent: {
        type: 'text',
        title: '欢迎按钮文案'
    },
    welcomeButtonTypeParent: {
        defaultValue: 0,
        title: '欢迎按钮类型'
    },

    welcomeBottomTextParent: {
        type: 'text',
        title: '底部文本文案'
    },
    welcomeButtonValueParent: {
        type: 'text',
        title: '欢迎按钮值'
    },
    totalGraduatedCountParent: {
        type: 'text',
        title: '总毕业人数'
    },
    avgPracticeTimeParent: {
        type: 'text',
        title: '总平均练习时间'
    },

    homePicUrlUkulele0: {
        type: 'image',
        title: 'ukulele手机背景图'
    },
    homePicUrlUkulele1: {
        type: 'image',
        title: 'ukulelePad背景图'
    },
    homePicUrlGuitar0: {
        type: 'image',
        title: 'guitar手机背景图'
    },
    homePicUrlGuitar1: {
        type: 'image',
        title: 'guitarPad背景图'
    },

    homePicUrlKalimba0: {
        type: 'image',
        title: '拇指琴手机背景图'
    },
    homePicUrlKalimba1: {
        type: 'image',
        title: '拇指琴Pad背景图'
    },

    homePicUrlDjembe0: {
        type: 'image',
        title: '非洲鼓手机背景图'
    },
    homePicUrlDjembe1: {
        type: 'image',
        title: '非洲鼓Pad背景图'
    },

    homePicUrlPiano0: {
        type: 'image',
        title: '钢琴手机背景图'
    },
    homePicUrlPiano1: {
        type: 'image',
        title: '钢琴Pad背景图'
    },

    homePicUrlHarmonica0: {
        type: 'image',
        title: '口琴手机背景图'
    },
    homePicUrlHarmonica1: {
        type: 'image',
        title: '口琴Pad背景图'
    },

    homePicUrlOther0: {
        type: 'image',
        title: 'other手机背景图'
    },
    homePicUrlOther1: {
        type: 'image',
        title: 'otherPad背景图'
    },

    homePicUrlSaxophone0: {
        type: 'image',
        title: '萨克斯手机背景图'
    },
    homePicUrlSaxophone1: {
        type: 'image',
        title: '萨克斯Pad背景图'
    },
    homePicUrlZhudi0: {
        type: 'image',
        title: '竹笛手机背景图'
    },
    homePicUrlZhudi1: {
        type: 'image',
        title: '竹笛Pad背景图'
    },
    homePicUrlBass0: {
        type: 'image',
        title: '贝斯手机背景图'
    },
    homePicUrlBass1: {
        type: 'image',
        title: '贝斯Pad背景图'
    },
    homePicUrlEguitar0: {
        type: 'image',
        title: '电吉他手机背景图'
    },
    homePicUrlEguitar1: {
        type: 'image',
        title: '电吉他Pad背景图'
    },
    homePicUrlGuzheng0: {
        type: 'image',
        title: '古筝手机背景图'
    },
    homePicUrlGuzheng1: {
        type: 'image',
        title: '古筝Pad背景图'
    },
    homePicUrlOcarina0: {
        type: 'image',
        title: '陶笛手机背景图'
    },
    homePicUrlOcarina1: {
        type: 'image',
        title: '陶笛Pad背景图'
    },

    homePicUrlVocal0: {
        type: 'image',
        title: '声乐手机背景图'
    },
    homePicUrlVocal1: {
        type: 'image',
        title: '声乐Pad背景图'
    },

    homePicUrlParent0: {
        type: 'image',
        title: '亲子手机背景图'
    },

    homePicUrlParent1: {
        type: 'image',
        title: '亲子Pad背景图'
    },

    backgroundVideo: {
        type: 'video',
        title: '手机背景视频'
    },
    backgroundPadVideo: {
        type: 'video',
        title: 'pad背景视频'
    },

    daxiangBackgroundPic: {
        type: 'image',
        title: '大向新手入门封面'
    },
    liushuqiBackgroundPic: {
        type: 'image',
        title: '柳舒淇新手入门封面'
    },

    guitarPurchaseInfo: {
        type: 'text',
        title: '吉他单课付费信息展示'
    },
    ukulelePurchaseInfo: {
        type: 'text',
        title: '尤克里里单课付费信息展示'
    },
    kalimbaPurchaseInfo: {
        type: 'text',
        title: '卡林巴单课付费信息展示'
    },
    djembePurchaseInfo: {
        type: 'text',
        title: '非洲鼓单课付费信息展示'
    },
    pianoPurchaseInfo: {
        type: 'text',
        title: '钢琴单课付费信息展示'
    },
    harmonicaPurchaseInfo: {
        type: 'text',
        title: '口琴单课付费信息展示'
    },
    otherPurchaseInfo: {
        type: 'text',
        title: '其他单课付费信息展示'
    },
    guzhengPurchaseInfo: {
        type: 'text',
        title: '古筝单课付费信息展示'
    },
    ocarinaPurchaseInfo: {
        type: 'text',
        title: '古筝单课付费信息展示'
    },

    vocalPurchaseInfo: {
        type: 'text',
        title: '声乐单课付费信息展示'
    },

    guitarSumPurchaseInfo: {
        type: 'text',
        title: '吉他总付费信息展示'
    },
    ukuleleSumPurchaseInfo: {
        type: 'text',
        title: '尤克里里总付费信息展示'
    },
    kalimbaSumPurchaseInfo: {
        type: 'text',
        title: '卡林巴总付费信息展示'
    },
    djembeSumPurchaseInfo: {
        type: 'text',
        title: '非洲鼓总付费信息展示'
    },
    pianoSumPurchaseInfo: {
        type: 'text',
        title: '钢琴总付费信息展示'
    },
    harmonicaSumPurchaseInfo: {
        type: 'text',
        title: '口琴总付费信息展示'
    },
    otherSumPurchaseInfo: {
        type: 'text',
        title: '其他总付费信息展示'
    },
    guzhengSumPurchaseInfo: {
        type: 'text',
        title: '古筝总付费信息展示'
    },
    ocarinaSumPurchaseInfo: {
        type: 'text',
        title: '陶笛总付费信息展示'
    },

    vocalSumPurchaseInfo: {
        type: 'text',
        title: '声乐总付费信息展示'
    },
    saxophoneSumPurchaseInfo: {
        type: 'text',
        title: '萨克斯总付费信息展示'
    },
    eguitarSumPurchaseInfo: {
        type: 'text',
        title: '电吉他总付费信息展示'
    },

    newGuitarPurchaseInfo: {
        type: 'text',
        title: '新吉他购买卡片数据'
    },

    newUkulelePurchaseInfo: {
        type: 'text',
        title: '新尤克里里购买卡片数据'
    },
    proLiveSumPurchaseInfo: {
        type: 'text',
        title: 'pro直播课购买卡片数据'
    },
    oneDayPush: {
        type: 'text',
        title: '每日推送'
    },
    threeDayPush: {
        type: 'text',
        title: '3日练琴提醒'
    },
    fiveDayPush: {
        type: 'text',
        title: '5日练琴提醒'
    },
    sevenDayPush: {
        type: 'text',
        title: '7日练琴提醒'
    },
    fifteenDayPush: {
        type: 'text',
        title: '15日练琴提醒'
    },
    thirtyDayPush: {
        type: 'text',
        title: '30日练琴提醒'
    },
    scoreSchema: {
        type: 'text',
        title: '曲谱库引导页配置'
    },

    disImageUrlBuyUkulele0: {
        type: 'image',
        title: '尤克里里购买时优惠劵图片'
    },
    disImageUrlGainUkulele0: {
        type: 'image',
        title: '尤克里里获得时优惠劵图片'
    },
    disImageUrlBuyGuitar0: {
        type: 'image',
        title: '吉他购买时优惠劵图片'
    },
    disImageUrlGainGuitar0: {
        type: 'image',
        title: '吉他获得时优惠劵图片'
    },
    disBannerTitleBuy: {
        type: 'text',
        title: '购买时优惠劵title'
    },
    disBannerTitleGain: {
        type: 'text',
        title: '获取时优惠劵title'
    },

    guitar: {
        type: 'text',
        title: '吉他提示'
    },

    ukulele: {
        type: 'text',
        title: '尤克里里提示'
    },

    parent: {
        type: 'text',
        title: '亲子提示'
    },

    oneLesson: {
        type: 'text',
        title: '第一课：'
    },
    twoLesson: {
        type: 'text',
        title: '第二课：'
    },
    threeLesson: {
        type: 'text',
        title: '第三课：'
    },
    fourLesson: {
        type: 'text',
        title: '第四课：'
    },
    fiveLesson: {
        type: 'text',
        title: '第五课：'
    },
    sixLesson: {
        type: 'text',
        title: '第六课：'
    },
    sevenLesson: {
        type: 'text',
        title: '第七课：'
    },
    eightLesson: {
        type: 'text',
        title: '第八课：'
    },
    nineLesson: {
        type: 'text',
        title: '第九课：'
    },
    tenLesson: {
        type: 'text',
        title: '第十课：'
    },
    elevenLesson: {
        type: 'text',
        title: '第十一课：'
    },
    twelveLesson: {
        type: 'text',
        title: '第十二课：'
    },
    thirteenLesson: {
        type: 'text',
        title: '第十三课：'
    },
    fourteenLesson: {
        type: 'text',
        title: '第十四课：'
    },
    fifteenLesson: {
        type: 'text',
        title: '第十五课：'
    },
    sixteenLesson: {
        type: 'text',
        title: '第十六课：'
    },
    seventeenLesson: {
        type: 'text',
        title: '第十七课：'
    },
    eighteenLesson: {
        type: 'text',
        title: '第十八课：'
    },
    nineteenLesson: {
        type: 'text',
        title: '第十九课：'
    },
    twentyLesson: {
        type: 'text',
        title: '第二十课：'
    },
    twentyOneLesson: {
        type: 'text',
        title: '第二十一课：'
    },
    twentyTwoLesson: {
        type: 'text',
        title: '第二十二课：'
    },
    twentyThreeLesson: {
        type: 'text',
        title: '第二十三课：'
    },
    twentyFourLesson: {
        type: 'text',
        title: '第二十四课：'
    },
    twentyFiveLesson: {
        type: 'text',
        title: '第二十五课：'
    },
    twentySixLesson: {
        type: 'text',
        title: '第二十六课：'
    },
    twentySevenLesson: {
        type: 'text',
        title: '第二十七课：'
    },
    twentyEightLesson: {
        type: 'text',
        title: '第二十八课：'
    },
    twentyNineLesson: {
        type: 'text',
        title: '第二十九课：'
    },
    thirtyLesson: {
        type: 'text',
        title: '第三十课：'
    },
    thirtyOneLesson: {
        type: 'text',
        title: '第三十一课：'
    },
    thirtyTwoLesson: {
        type: 'text',
        title: '第三十二课：'
    },
    thirtyThreeLesson: {
        type: 'text',
        title: '第三十三课：'
    },
    thirtyFourLesson: {
        type: 'text',
        title: '第三十四课：'
    },
    thirtyFiveLesson: {
        type: 'text',
        title: '第三十五课：'
    },
    thirtySixLesson: {
        type: 'text',
        title: '第三十六课：'
    },
    thirtySevenLesson: {
        type: 'text',
        title: '第三十七课：'
    },
    thirtyEightLesson: {
        type: 'text',
        title: '第三十八课：'
    },
    thirtyNineLesson: {
        type: 'text',
        title: '第三十九课：'
    },
    fortyLesson: {
        type: 'text',
        title: '第四十课：'
    },
    fortyOneLesson: {
        type: 'text',
        title: '第四十一课：'
    },
    fortyTwoLesson: {
        type: 'text',
        title: '第四十二课：'
    },
    fortyThreeLesson: {
        type: 'text',
        title: '第四十三课：'
    },
    fortyFourLesson: {
        type: 'text',
        title: '第四十四课：'
    },
    fortyFiveLesson: {
        type: 'text',
        title: '第四十五课：'
    },

    oneLessonGuitar: {
        type: 'text',
        title: '吉他第一课：'
    },
    twoLessonGuitar: {
        type: 'text',
        title: '吉他第二课：'
    },
    threeLessonGuitar: {
        type: 'text',
        title: '吉他第三课：'
    },
    fourLessonGuitar: {
        type: 'text',
        title: '吉他第四课：'
    },
    fiveLessonGuitar: {
        type: 'text',
        title: '吉他第五课：'
    },
    sixLessonGuitar: {
        type: 'text',
        title: '吉他第六课：'
    },
    sevenLessonGuitar: {
        type: 'text',
        title: '吉他第七课：'
    },
    eightLessonGuitar: {
        type: 'text',
        title: '吉他第八课：'
    },
    nineLessonGuitar: {
        type: 'text',
        title: '吉他第九课：'
    },
    tenLessonGuitar: {
        type: 'text',
        title: '吉他第十课：'
    },
    elevenLessonGuitar: {
        type: 'text',
        title: '吉他第十一课：'
    },
    twelveLessonGuitar: {
        type: 'text',
        title: '吉他第十二课：'
    },
    thirteenLessonGuitar: {
        type: 'text',
        title: '吉他第十三课：'
    },
    fourteenLessonGuitar: {
        type: 'text',
        title: '吉他第十四课：'
    },
    fifteenLessonGuitar: {
        type: 'text',
        title: '吉他第十五课：'
    },

    sixteenLessonGuitar: {
        type: 'text',
        title: '吉他第十六课：'
    },
    seventeenLessonGuitar: {
        type: 'text',
        title: '吉他第十七课：'
    },
    eighteenLessonGuitar: {
        type: 'text',
        title: '吉他第十八课：'
    },
    nineteenLessonGuitar: {
        type: 'text',
        title: '吉他第十九课：'
    },
    twentyLessonGuitar: {
        type: 'text',
        title: '吉他第二十课：'
    },
    twentyOneLessonGuitar: {
        type: 'text',
        title: '吉他第二十一课：'
    },
    twentyTwoLessonGuitar: {
        type: 'text',
        title: '吉他第二十二课：'
    },
    twentyThreeLessonGuitar: {
        type: 'text',
        title: '吉他第二十三课：'
    },
    twentyFourLessonGuitar: {
        type: 'text',
        title: '吉他第二十四课：'
    },
    twentyFiveLessonGuitar: {
        type: 'text',
        title: '吉他第二十五课：'
    },
    twentySixLessonGuitar: {
        type: 'text',
        title: '吉他第二十六课：'
    },
    twentySevenLessonGuitar: {
        type: 'text',
        title: '吉他第二十七课：'
    },
    twentyEightLessonGuitar: {
        type: 'text',
        title: '吉他第二十八课：'
    },
    twentyNineLessonGuitar: {
        type: 'text',
        title: '吉他第二十九课：'
    },
    thirtyLessonGuitar: {
        type: 'text',
        title: '吉他第三十课：'
    },
    thirtyOneLessonGuitar: {
        type: 'text',
        title: '吉他第三十一课：'
    },
    thirtyTwoLessonGuitar: {
        type: 'text',
        title: '吉他第三十二课：'
    },
    thirtyThreeLessonGuitar: {
        type: 'text',
        title: '吉他第三十三课：'
    },
    thirtyFourLessonGuitar: {
        type: 'text',
        title: '吉他第三十四课：'
    },
    thirtyFiveLessonGuitar: {
        type: 'text',
        title: '吉他第三十五课：'
    },
    thirtySixLessonGuitar: {
        type: 'text',
        title: '吉他第三十六课：'
    },
    thirtySevenLessonGuitar: {
        type: 'text',
        title: '吉他第三十七课：'
    },
    thirtyEightLessonGuitar: {
        type: 'text',
        title: '吉他第三十八课：'
    },
    thirtyNineLessonGuitar: {
        type: 'text',
        title: '吉他第三十九课：'
    },
    fortyLessonGuitar: {
        type: 'text',
        title: '吉他第四十课：'
    },
    fortyOneLessonGuitar: {
        type: 'text',
        title: '吉他第四十一课：'
    },
    fortyTwoLessonGuitar: {
        type: 'text',
        title: '吉他第四十二课：'
    },
    fortyThreeLessonGuitar: {
        type: 'text',
        title: '吉他第四十三课：'
    },
    fortyFourLessonGuitar: {
        type: 'text',
        title: '吉他第四十四课：'
    },
    fortyFiveLessonGuitar: {
        type: 'text',
        title: '吉他第四十五课：'
    },

    oneLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第一课：'
    },
    twoLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第二课：'
    },
    threeLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第三课：'
    },
    fourLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第四课：'
    },
    fiveLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶五课：'
    },
    sixLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第六课：'
    },
    sevenLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第七课：'
    },
    eightLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第八课：'
    },
    nineLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第九课：'
    },
    tenLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第十课：'
    },
    elevenLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第十一课：'
    },
    twelveLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第十二课：'
    },
    thirteenLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第十三课：'
    },
    fourteenLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第十四课：'
    },
    fifteenLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第十五课：'
    },

    sixteenLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第十六课：'
    },
    seventeenLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第十七课：'
    },
    eighteenLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第十八课：'
    },
    nineteenLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第十九课：'
    },
    twentyLessonGuitarDAdvance: {
        type: 'text',
        title: '吉他d进阶第二十课：'
    },

    freeExperienceIds: {
        type: 'text',
        title: '免注册课程配置'
    },
    lessonContrastSix: {
        type: 'text',
        title: '免注册课程对应关系展示'
    },
    androidHotUpdateVersion: {
        type: 'text',
        title: 'android热更新版本对应关系'
    },
    androidVersionOpenUpdate: {
        type: 'text',
        title: 'android各版本热更新是否开启对应关系'
    },
    harmonyHotUpdateVersion: {
        type: 'text',
        title: '鸿蒙热更新版本对应关系'
    },
    harmonyVersionOpenUpdate: {
        type: 'text',
        title: '鸿蒙各版本热更新是否开启对应关系'
    },
    iosHotUpdateVersion: {
        type: 'text',
        title: 'ios热更新版本对应关系'
    },
    iosVersionOpenUpdate: {
        type: 'text',
        title: 'ios各版本热更新是否开启对应关系'
    },
    hasLoginBannerAdvertUrlNew: {
        type: 'text',
        title: '广告链接地址'
    },
    loginTipBannerUrlNew: {
        type: 'image',
        title: '登录界面弹窗banner'
    },
    loginTipStringNew: {
        type: 'text',
        title: '登录界面弹窗提示文字'
    },
    userInitialPath: {
        type: 'text',
        title: '小涛智能推荐老课42路径'
    },
    fixedKnowledgePath196: {
        type: 'text',
        title: '小涛新课196知识点路径'
    },
    fixedKnowledgePath199: {
        type: 'text',
        title: '都吉他新课199知识点路径'
    },
    fixedKnowledgePath213: {
        type: 'text',
        title: '都老师吉他进阶知识点路径'
    },
    openTestTime: {
        type: 'text',
        title: '开始时间'
    },
    endTestTime: {
        type: 'text',
        title: '结束时间'
    },
    openAndCloseTest: {
        title: '是否开启',
        type: 'boolean',
        defaultValue: false
    },
    guitarThisWeekRecom: {
        type: 'text',
        title: '吉他本周推荐'
    },
    ukuleleThisWeekRecom: {
        type: 'text',
        title: '尤克里里本周推荐'
    },
    kalimbaThisWeekRecom: {
        type: 'text',
        title: '卡淋巴本周推荐'
    },

    djembeThisWeekRecom: {
        type: 'text',
        title: '非洲鼓本周推荐'
    },

    pianoThisWeekRecom: {
        type: 'text',
        title: '钢琴本周推荐'
    },
    rollAd: {
        type: 'text',
        title: '滚动广告配置'
    },
    whiteListPhone: {
        type: 'text',
        title: '防共享uid白名单'
    },
    whiteListEquipment: {
        type: 'text',
        title: '防共享设备白名单'
    },

    forUkTestCourse: {
        type: 'text',
        title: '测试ukulele课程'
    },
    forGtTestCourse: {
        type: 'text',
        title: '测试guitar课程'
    },
    testCourseUsers: {
        type: 'text',
        title: '测试人员'
    },

    androidVersionBangtabs: {
        type: 'string',
        title: 'Android版本'
    },
    iosVersionBangtabs: {
        type: 'string',
        title: 'iOS版本'
    },
    androidReviewVersionBangtabs: {
        type: 'string',
        title: 'Android审核版本'
    },
    iosReviewVersionBangtabs: {
        type: 'string',
        title: 'iOS审核版本'
    },
    androidNewVersionBangtabs: {
        type: 'string',
        title: 'Android-Assetbundle版本'
    },
    iosNewVersionBangtabs: {
        type: 'string',
        title: 'ios-Assetbundle版本'
    },

    isAndroidUpdateBangtabs: {
        type: 'boolean',
        title: '开启Android更新'
    },

    isIosUpdateBangtabs: {
        type: 'boolean',
        title: '开启iOS更新'
    },

    androidUpdateDescriptionBangtabs: {
        type: 'text',
        title: 'Android更新文案'
    },
    iosUpdateDescriptionBangtabs: {
        type: 'text',
        title: 'iOS更新文案'
    },
    iosForceUpdateBangtabs: {
        type: 'boolean',
        title: 'ios强制更新'
    },
    androidForceUpdateBangtabs: {
        type: 'boolean',
        title: 'android强制更新'
    },
    androidHotUpdateVersionBangtabs: {
        type: 'text',
        title: 'android热更新版本对应关系'
    },
    androidVersionOpenUpdateBangtabs: {
        type: 'text',
        title: 'android各版本热更新是否开启对应关系'
    },
    iosHotUpdateVersionBangtabs: {
        type: 'text',
        title: 'ios热更新版本对应关系'
    },
    iosVersionOpenUpdateBangtabs: {
        type: 'text',
        title: 'ios各版本热更新是否开启对应关系'
    },
    channelRedirectList: {
        type: 'text',
        title: '渠道信息'
    },
    wechatTeacherConfig: {
        type: 'text',
        title: '微信配置'
    },
    wechatTeacherImageUrl: {
        type: 'image',
        title: '微信二维码'
    },
    resourceLinkConfig: {
        type: 'text',
        title: '资源链路配置'
    },
    courseCatalogConfig: {
        type: 'text',
        title: '课程目录配置'
    },
    yfbProportionalAllocation: {
        type: 'text',
        title: '音符币比例配置'
    },
    activityConfig: {
        type: 'text',
        title: '活动配置'
    },
    vipCouponConfig: {
        type: 'text',
        title: 'VIP优惠券配置'
    },
    virtualGoodsConfig: {
        type: 'text',
        title: '虚拟商品配置'
    },
    goodsMapConfig: {
        type: 'text',
        title: '商品配置'
    },
    vipCategoryConfig: {
        type: 'text',
        title: 'vip品类配置'
    },
    exhibitionCategoryConfig: {
        type: 'text',
        title: '活动品类配置'
    },
    popups: {
        type: 'text',
        title: '活动弹出框配置'
    },
    manuals: {
        type: 'text',
        title: '渠道配置'
    },
    scoreGuide: {
        type: 'text',
        title: '曲谱引导至课程配置'
    },
    abTesting: {
        type: 'text',
        title: 'AB测试配置'
    },
    gameTypes: {
        type: 'text',
        title: '游戏类型配置'
    },

    isUseHttpDns:{
        type: "boolean",
        title: "是否使用dns",
        defaultValue: false
    },
    httpReqFailIsToast:{
        type: "boolean",
        title: "http 请求失败是否显示Toast 提示",
        defaultValue: false
    },

    privacyPolicy :{
        type:"text",
        title: "隐私政策更新",
    },
    serviceAgreement: {
        type:"text",
        title: "服务协议更新",
    },
    updateNotificationTxt: {
        type:"text",
        title: "更新通知文案",
    },
    codePostern: {
        type: 'text',
        title: '验证码后门'
    },
    testUids: {
        type: 'text',
        title: '新测试用户ID'
    },
    testTels: {
        type: 'text',
        title: '新测试用户手机号'
    },
};



// WEBPACK FOOTER //
// src/helpers/ConfigsHelper.js